export const getTypeColors = (): any => {
	return {
		featured: {
			badge: {
				background: "bg-orange-500",
				text: "text-white",
			},
			hover: "hover:bg-orange-300/20 focus:bg-orange-300/20",
			group: "group-hover:bg-orange-300/20 group-focus:bg-orange-300/20",
		},
		resource: {
			badge: {
				background: "bg-pistachio-300",
				text: "text-pistachio-700",
			},
			hover: "hover:bg-pistachio-300/20 focus:bg-pistachio-300/20",
			group: "group-hover:bg-pistachio-300/20 group-focus:bg-pistachio-300/20",
		},
		primary: {
			badge: {
				background: "bg-concrete-300",
				text: "text-concrete-700",
			},
			hover: "hover:bg-concrete-300/20 focus:bg-concrete-300/20",
			group: "group-hover:bg-concrete-300/20 group-focus:bg-concrete-300/20",
		},
		blog: {
			badge: {
				background: "bg-ocean-green-300",
				text: "text-ocean-green-700",
			},
			hover: "hover:bg-ocean-green-300/20 focus:bg-ocean-green-300/20",
			group: "group-hover:bg-ocean-green-300/20 group-focus:bg-ocean-green-300/20",
		},
		caseStudy: {
			badge: {
				background: "bg-pistachio-300",
				text: "text-pistachio-700",
			},
			hover: "hover:bg-pistachio-300/20 focus:bg-pistachio-300/20",
			group: "group-hover:bg-pistachio-300/20 group-focus:bg-pistachio-300/20",
		},
		event: {
			badge: {
				background: "bg-sky-blue-300",
				text: "text-sky-blue-700",
			},
			hover: "hover:bg-sky-blue-300/20 focus:bg-sky-blue-300/20",
			group: "group-hover:bg-sky-blue-300/20 group-focus:bg-sky-blue-300/20",
		},
		dossier: {
			badge: {
				background: "bg-viridian-300",
				text: "text-viridian-700",
			},
			hover: "hover:bg-viridian-300/20 focus:bg-viridian-300/20",
			group: "group-hover:bg-viridian-300/20 group-focus:bg-viridian-300/20",
		},
		file: {
			badge: {
				background: "bg-viridian-300",
				text: "text-viridian-700",
			},
			hover: "hover:bg-viridian-300/20 focus:bg-viridian-300/20",
			group: "group-hover:bg-viridian-300/20 group-focus:bg-viridian-300/20",
		},
		news: {
			badge: {
				background: "bg-sky-blue-300",
				text: "text-sky-blue-700",
			},
			hover: "hover:bg-sky-blue-300/20 focus:bg-sky-blue-300/20",
			group: "group-hover:bg-sky-blue-300/20 group-focus:bg-sky-blue-300/20",
		},
		pressRelease: {
			badge: {
				background: "bg-concrete-300",
				text: "text-concrete-700",
			},
			hover: "hover:bg-concrete-300/20 focus:bg-concrete-300/20",
			group: "group-hover:bg-concrete-300/20 group-focus:bg-concrete-300/20",
		},
		whitepaper: {
			badge: {
				background: "bg-viridian-300",
				text: "text-viridian-700",
			},
			hover: "hover:bg-viridian-300/20 focus:bg-viridian-300/20",
			group: "group-hover:bg-viridian-300/20 group-focus:bg-viridian-300/20",
		},
	};
};

export const getLocationColors = (): any => {
	return {
		available: {
			badge: {
				background: "bg-ocean-green-400",
				text: "text-white",
			},
			marker: {
				background: "bg-ocean-green-500",
				fill: "fill-ocean-green-400",
				text: "text-white",
			},
			border: "border-2 border-viridian-300",
			hover: "hover:bg-viridian-300 focus:bg-viridian-300",
		},
		// partially: {
		//     badge: {
		//         background: 'bg-celestial-500',
		//         text: 'text-white'
		//     },
		//     border: 'border-2 border-celestial-300',
		//     hover: 'hover:bg-celestial-300 focus:bg-celestial-300'
		// },
		// out: {
		//     badge: {
		//         background: 'bg-concrete-700',
		//         text: 'text-concrete-300'
		//     },
		//     border: 'border-2 border-concrete-300',
		//     hover: 'hover:bg-concrete-300 focus:bg-concrete-300'
		// },
		soon: {
			badge: {
				background: "bg-sky-blue-900",
				text: "text-white",
			},
			marker: {
				background: "bg-sky-blue-900",
				fill: "fill-sky-blue-900",
				text: "text-white",
			},
			border: "border-2 border-sky-blue-900",
			hover: "hover:bg-sky-blue-900 focus:bg-sky-blue-900",
		},
	};
};
